import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) {
            // Reset to 15 mins to simulate urgency loop or stop
            return {
              minutes: 15,
              seconds: 0
            };
          }
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex flex-col items-center space-y-2 my-6" data-id="element-186">
      <div className="flex items-center gap-2 text-red-500 font-mono text-2xl md:text-3xl font-bold tracking-widest bg-red-500/10 px-6 py-3 rounded border border-red-500/20" data-id="element-187">
        <span data-id="element-188">00</span>
        <span data-id="element-189">:</span>
        <span data-id="element-190">{timeLeft.minutes.toString().padStart(2, '0')}</span>
        <span data-id="element-191">:</span>
        <span data-id="element-192">{timeLeft.seconds.toString().padStart(2, '0')}</span>
      </div>
      <p className="text-red-400 text-xs uppercase tracking-widest font-medium animate-pulse" data-id="element-193">
        Price increases after timer ends
      </p>
    </div>;
}